import script from "./VideoLiveStream.vue?vue&type=script&setup=true&lang=ts"
export * from "./VideoLiveStream.vue?vue&type=script&setup=true&lang=ts"

import "./VideoLiveStream.vue?vue&type=style&index=0&id=3e866096&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e866096"]])

export default __exports__